import * as React from "react";
import { PulseBetButton } from "../../../../components/PulseBetButton";
const baseClass = "rj-pulse-bet-market__accepted-bet";
export class AcceptedBet extends React.Component {
    //currently for the handler it is unclear what it should do from bussiness side so for now we removing onClick
    render() {
        return (React.createElement("div", { className: `${baseClass}-container`, onClick: this.props.data.areaHandler },
            React.createElement("div", { className: `${baseClass}-message` }, this.props.data.message),
            React.createElement("div", { className: `${baseClass}-ticket-container` },
                React.createElement("span", { className: `${baseClass}-interval` }, this.props.data.timeInterval),
                React.createElement("span", { className: `${baseClass}-ticket` }, this.props.data.ticketLabel),
                React.createElement("span", { className: `${baseClass}-number` }, this.props.data.ticketId)),
            React.createElement(PulseBetButton, { modifier: "accepted-bet", handler: this.props.data.handler }, this.props.data.buttonLabel)));
    }
}
//# sourceMappingURL=AcceptedBet.js.map